<template>
  <nav class="navbar is-fixed-top is-black" role="navigation" aria-label="main navigation">
    <div class="navbar-brand">
      <a class="navbar-item" href="/">
        <img src="https://gapp.wisestamp.com/img/wisestamp-corporate-logo.svg" alt="Wisestamp for Teams">
      </a>

      <a role="button" class="navbar-burger" aria-label="menu" aria-expanded="false" data-target="commonNavbar">
        <span aria-hidden="true"></span>
        <span aria-hidden="true"></span>
        <span aria-hidden="true"></span>
      </a>
    </div>

    <div id="commonNavbar" class="navbar-menu">
      <div class="navbar-start">
        <a v-if="getAdmin"
           class="navbar-item"
           @click="$router.push({name: 'Domain', query: {'q': getAdmin.domain}})">
          {{ getAdmin.domain }}
        </a>
        <a class="navbar-item" @click="$router.push({name: 'Domain'})">
          Search by Domain
        </a>
      </div>

      <div class="navbar-end">
        <div v-if="getAdmin" class="navbar-item has-dropdown"
             :class="{'is-active': dropdown}"
             @click="dropdown = !dropdown">
          <a class="navbar-link">
            {{ getAdmin.email }}
          </a>
          <div class="navbar-dropdown">
            <a class="navbar-item" @click="$router.push({name: 'Logout'})">
              Log Out
            </a>
          </div>
        </div>
        <div v-else class="navbar-item">
          <div class="buttons">
            <button class="button is-light" @click="$router.push({name: 'Login'})">
              Log In
            </button>
          </div>
        </div>
      </div>
    </div>
  </nav>
</template>

<script>
import {mapActions, mapGetters} from "vuex";

export default {
  name: "Navbar",
  data() {
    return {
      dropdown: false,
    }
  },
  methods: {
    ...mapActions('auth', ['currentAdmin']),
    responsiveNavbar() {
      // Get all "navbar-burger" elements
      const $navbarBurgers = Array.prototype.slice.call(document.querySelectorAll('.navbar-burger'), 0);

      // Check if there are any navbar burgers
      if ($navbarBurgers.length > 0) {

        // Add a click event on each of them
        $navbarBurgers.forEach(el => {
          el.addEventListener('click', () => {

            // Get the target from the "data-target" attribute
            const target = el.dataset.target;
            const $target = document.getElementById(target);

            // Toggle the "is-active" class on both the "navbar-burger" and the "navbar-menu"
            el.classList.toggle('is-active');
            $target.classList.toggle('is-active');

          });
        });
      }
    },
  },
  computed: {
    ...mapGetters('auth', ['getAdmin']),
  },
  mounted() {
    this.responsiveNavbar()
    this.currentAdmin()
  }
}
</script>

<style scoped>

</style>
